import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import APIS from "../constant/Endpoint";
import usePostHook from "../customHooks/usePostHook";
import Button from "./Button";
import CompanyCombobox from "./CompanyCombobox";
import { setKey } from "../helpers/sessionKey";

const SwitchCompany = (props) => {
  const { profile } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {};
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ddfault-branch"],
  });

  const handleUpdate = async (values: any) => {
    console.log(values?.company, "values");
    localStorage.setItem("schema_name", values?.company);
    window.location.reload();
  };

  return (
    <div className={tw`px-4`}>
      <CompanyCombobox
        label={"Company"}
        placeholder={"Select Company"}
        url={APIS.ORGANIZATION}
        queryKey={"company"}
        register={register("company")}
        errors={errors?.company}
        name={"company"}
        getValues={getValues}
        params={{ user: profile?.id }}
        setValue={setValue}
        clearErrors={clearErrors}
        profile={profile}
      />
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[100px] `}>
          <Button
            label={"Submit"}
            isLoading={isPostLoading}
            onClick={handleSubmit((data: any) => handleUpdate(data))}
          />
        </div>
      </div>
    </div>
  );
};

export default SwitchCompany;
